import styled from 'styled-components';
import {
  space,
  width,
  order,
  color,
  height,
  shadow,
  border,
  flexbox,
  display,
  minWidth,
  fontSize,
  typography,
  background,
  borderColor,
  borderRadius,
} from 'styled-system';
// helpers
import * as G from '../helpers';
//////////////////////////////////////////////////

export const Button = styled.button`
  ${space}
  ${width}
  ${order}
  ${color}
  ${shadow}
  ${height}
  ${border}
  ${display}
  ${flexbox}
  ${fontSize}
  ${background}

  outline: 0;
  border: none;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: middle;

  cursor: ${({ cursor }) => cursor || 'pointer'};
`;

export const InstanceButton = styled(Button)`
  ${width}
  ${minWidth}

  display: ${({ display }) => display};
  border: ${({ border }) => border || 'none'};
  z-index: ${({ zIndex }) => zIndex || 'unset'};
  background: ${({ background }) => background};
  font-weight: ${({ fontWeight }) => fontWeight};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  text-transform: ${({ textTransform }) => textTransform};
  visibility: ${({ visibility }) => visibility || 'visible'};
`;

InstanceButton.defaultProps = {
  height: 40,
  minWidth: 100,
  borderRadius: '2px',
};

export const ActionButton = styled(InstanceButton)`
  border-color: ${({ borderColor }) => borderColor};
  background-color: ${({ bgColor }) => bgColor || G.getTheme('colors.dark.blue')};
  color: ${({ textColor }) => textColor || G.getTheme('buttons.saveBtn.textColor')};

  ${({ disabled }) => disabled && `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const MainActionButton = styled.button`
  ${space}
  ${color}
  ${width}
  ${border}
  ${display}
  ${height}
  ${fontSize}
  ${minWidth}
  ${typography}
  ${borderColor}
  ${borderRadius}

  outline: 0;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: middle;

  cursor: ${({ cursor }) => cursor || 'pointer'};
  text-transform: ${({ textTransform }) => textTransform};

  ${({ disabled }) => disabled && `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

MainActionButton.defaultProps = {
  height: 32,
  bg: 'white',
  p: '4px 8px',
  minWidth: 60,
  fontSize: 14,
  border: '1px solid',
  borderRadius: '5px',
  color: 'dark.darkBlue',
  borderColor: 'dark.darkBlue',
};

export const MainDarkActionButton = styled(MainActionButton)`
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid ${G.getTheme('colors.borderGray')};
`;

MainDarkActionButton.defaultProps = {
  height: 'auto',
  color: G.getTheme('colors.dark.mainDark'),
};

const ModalButton = styled(InstanceButton)`
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 20px;
  text-transform: capitalize;
  transition: background-color 0.15s ease;

  border: ${({ border }) => border || '1px solid'};
  border-color: ${({ borderColor }) => borderColor || G.getTheme('colors.borderGray')};

  ${({ disabled }) => disabled && `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

ModalButton.defaultProps = {
  height: 32,
  fontSize: '15px',
};

export const ModalCancelButton = styled(ModalButton)`
  background-color: ${({ bgColor }) => bgColor || G.getTheme('colors.white')};
  color: ${({ textColor }) => textColor || G.getTheme('colors.greyMatterhorn')};

  &:hover {
    background-color: ${({ bgColor, hoverBgColor }) => (
      hoverBgColor || bgColor || G.getTheme('colors.bgLightGrey')
    )};
  }
`;

export const ModalActionButton = styled(ModalButton)`
  color: ${({ textColor }) => textColor || G.getTheme('colors.white')};
  background-color: ${({ bgColor }) => bgColor || G.getTheme('colors.textDark')};

  &:hover {
    background-color: ${({ bgColor, hoverBgColor }) => (
      hoverBgColor || bgColor || G.getTheme('colors.black')
    )};
  }
`;
